import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminLogin.css";
import { FaUserShield, FaLock } from "react-icons/fa";
import { loginUser } from "../api/api";

const AdminLogin = ({ setAdminData }) => {
  // const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [credentials, setCredentials] = useState({ identifier: "", password: "" });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await loginUser(credentials);
      console.log("🚀 loginUser response.data:", response.data);
      
      if (response.data.user && response.data.user.role === "admin") {
        setAdminData(response.data.user);
        localStorage.setItem("admin", JSON.stringify(response.data.user));
        alert("Admin login successful");
        navigate("/admin/dashboard");
      } else {
        alert("Invalid admin credentials");
      }
    } catch (error) {
      console.error("Admin login error:", error);
      alert("Admin login failed");
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h2>Admin Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <FaUserShield className="icon" />
            <input type="email" name="identifier" placeholder="Admin Email" onChange={handleChange} required />
          </div>
          <div className="input-group">
            <FaLock className="icon" />
            <input type="password" name="password" placeholder="Password" onChange={handleChange} required />
          </div>
          <button type="submit" className="login-btn">Login as Admin</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
